import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Translate } from 'react-localize-redux';
import Button from '../../components/atoms/Button';
import { PROMPT_PREVIEW_MAX_LENGTH, TRANSLATION_KEY } from '../constants';
import css from './PromptPreview.css';

const CARD_KEY = `${TRANSLATION_KEY}.CARD`;

const PromptPreview = ({ prompt, className = null, compact = false, onClick = undefined }) => {
    const [showFullPrompt, setShowFullPrompt] = useState(false);

    const isLong = prompt.length > PROMPT_PREVIEW_MAX_LENGTH;

    return (
        <div className={classNames(css.block, className, { [css.compact]: compact })} onClick={onClick}>
            <div className={classNames(css.prompt, { [css.clamped]: isLong && !showFullPrompt })}>{prompt}</div>
            {isLong && (
                <Button type="link" className={css.toggle} onClick={() => setShowFullPrompt(shown => !shown)}>
                    <Translate id={`${CARD_KEY}.${showFullPrompt ? 'HIDE_PROMPT' : 'SHOW_PROMPT'}`} />
                </Button>
            )}
        </div>
    );
};

PromptPreview.propTypes = {
    prompt: PropTypes.string.isRequired,
    className: PropTypes.string,
    compact: PropTypes.bool,
    onClick: PropTypes.func,
};

export default PromptPreview;
